import * as Constants from '../constants/';

import uuidv1 from 'uuid/v1';

const initialState = {
  isLoading: false,
  error: null,
  data: {
    profile: {},
    loaded: {},
    blocks: []
  }
};

function deleteTagFromProfile(profile, tag) {
  const updatedProfile = { ...profile };
  if (updatedProfile.tags) {
    const index = updatedProfile.tags.findIndex(
      existingTag => tag.id === existingTag.id
    );
    if (index >= 0) {
      updatedProfile.tags = [...updatedProfile.tags];
      updatedProfile.tags.splice(index, 1);
    }
  }
  return updatedProfile;
}

function mergeTagOnProfile(profile, tag) {
  let updatedMetadata = [];
  if (profile.tags) {
    updatedMetadata = [...profile.tags];
    const index = updatedMetadata.findIndex(
      existingTag => tag.id === existingTag.id
    );
    if (index >= 0) {
      updatedMetadata.splice(index, 1, { ...tag });
    } else {
      tag.id = uuidv1();
      updatedMetadata.push({ ...tag });
    }
  } else {
    tag.id = uuidv1();
    updatedMetadata = [{ ...tag }];
  }
  return {
    ...profile,
    tags: updatedMetadata
  };
}

function addIdsToTags(profile) {
  if (profile.tags && profile.tags.length) {
    profile.tags = profile.tags.map(tag => ({
      ...tag,
      id: uuidv1()
    }));
  }
  return profile;
}

export default function(state = initialState, action) {
  switch (action.type) {
    case Constants.RECEIVE_PROFILE:
    case Constants.RECEIVE_UPDATE_PROFILE:
      if (action.error) {
        return { ...state, isLoading: false, error: action.error };
      }
      const profile = addIdsToTags(action.data);
      return {
        ...state,
        isLoading: false,
        data: {
          ...state.data,
          profile,
          loaded: { ...profile }
        }
      };
    case Constants.UPDATE_PROFILE_TAG:
      return {
        ...state,
        isLoading: false,
        data: {
          ...state.data,
          profile: mergeTagOnProfile(state.data.profile, action.tag),
          loaded: { ...state.data.loaded }
        }
      };
    case Constants.DELETE_PROFILE_TAG:
      return {
        ...state,
        isLoading: false,
        data: {
          ...state.data,
          profile: deleteTagFromProfile(state.data.profile, action.tag),
          loaded: { ...state.data.loaded }
        }
      };
    case Constants.RECEIVE_BLOCKS:
      if (action.error) {
        return { ...state, isSaving: false, error: action.error };
      }
      return {
        ...state,
        isSaving: false,
        data: {
          ...state.data,
          blocks: action.data.blocks
        }
      };
    default:
      return state;
  }
}
